module.exports = __webpack_public_path__ + "media/images/athletes/2199-5fa671f926bd995b1ec1e7aa46f2d98d.png";